export function TRANSLATE(str: string) {
    return str;
}